import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useRole } from '@/hooks/useRole';
import { useTranslation } from 'react-i18next';

const KITCHEN_ALLOWED = ['/kitchen', '/order-assist', '/prep'];
const SERVICE_ALLOWED = ['/service'];

export function RoleGuard({ children }: { children: ReactNode }) {
  const { role, loading } = useRole();
  const { t } = useTranslation();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-muted-foreground">{t('common.loading')}</div>
      </div>
    );
  }

  // No profile, or 'all' role → no restrictions
  if (role === null || role === 'all') return <>{children}</>;

  const path = location.pathname;

  if (role === 'service') {
    if (SERVICE_ALLOWED.some(p => path === p || path.startsWith(p + '/'))) {
      return <>{children}</>;
    }
    return <Navigate to="/service" replace />;
  }

  if (role === 'kitchen') {
    if (KITCHEN_ALLOWED.some(p => path === p || path.startsWith(p + '/')) || path === '/') {
      return <>{children}</>;
    }
    return <Navigate to="/kitchen" replace />;
  }

  return <>{children}</>;
}
